import moment from 'moment';
import React, { Component } from 'react';

import ReactTooltip from 'react-tooltip';

import {
  getIcon
} from '../../util';

class DealCloseDate extends Component {

  render(){
    const { deal } = this.props;
    const { estimatedCloseDate } = deal;

    if(!deal || !estimatedCloseDate){
      return null;
    }

    if(deal.status === 'open' && moment().diff(estimatedCloseDate) > 0){
      const tooltipId = `close-date-warning-for-deal-${deal._id}`;
      return (
        <React.Fragment>
          <span className="deal-close-date" data-for={tooltipId} data-tip="Estimated close date is past, needs updating.">{moment(estimatedCloseDate).format('MM/DD/YY')} {getIcon('warning-filled')}</span>
          <ReactTooltip id={tooltipId} effect="solid" place="top" />
        </React.Fragment>
      );
    }
    else{
      return <span className="deal-close-date">{moment(estimatedCloseDate).format('MM/DD/YY')}</span>
    }
  }
}

export default DealCloseDate;



// WEBPACK FOOTER //
// ./src/components/shared/dealCloseDate.js